import create from 'zustand'

export const useStore = create((set) => ({
    active_location: null,
    setActiveLocation: (location) => set((state) => ({ active_location: location })),
    location_data: null,
    setLocationData: (location_data) => set((state) => ({ location_data: location_data })),
    chart_range: 'week',
    setChartRange: (chart_range) => set((state) => ({ chart_range: chart_range })),
}))
